import type { ChartOptions, StrikeZone } from '../../../schema/types.ts'

const realZones = new Set<StrikeZone>(['personal'])
export default function shouldShowNormalized(
    chartOptions: ChartOptions,
    strikeZone: StrikeZone
) {
    if (typeof chartOptions.normalize === 'boolean') {
        return chartOptions.normalize
    }

    return !realZones.has(strikeZone)
}
